const { loadScripts } = Mobi2Go.helpers;

delete window.grecaptcha;

const recaptcha_site_key = '6LeAFSUaAAAAAMBFG9d1e299g36oniZroquBvfXl';
const recaptcha_url = `https://www.google.com/recaptcha/api.js?render=${recaptcha_site_key}`;

export default () => {
    return new Promise((resolve, reject) => {
        try {
            const executeReCaptcha = () => {
                const { grecaptcha } = window;

                if (!grecaptcha) {
                    reject(new Error('expected window.grecaptcha'));
                    return;
                }

                grecaptcha.ready(() => {
                    grecaptcha
                        .execute(recaptcha_site_key, { action: 'submit' })
                        .then(resolve)
                        .catch(reject);
                });
            };

            if (window.grecaptcha) {
                executeReCaptcha();
            } else {
                loadScripts([recaptcha_url], true, executeReCaptcha);
            }
        } catch {
            reject();
        }
    });
};
